var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("商家代采汇总详情")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "c_page-title" }, [
        _c("div", [
          _c("span", { staticStyle: { color: "#666", "font-size": "14px" } }, [
            _vm._v("商家ID：" + _vm._s(_vm.localData.supply_id))
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                "margin-left": "120px",
                color: "#666",
                "font-size": "14px"
              }
            },
            [_vm._v("商家：" + _vm._s(_vm.localData.supply_name))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                "margin-left": "120px",
                color: "#666",
                "font-size": "14px"
              }
            },
            [_vm._v("代采订单：" + _vm._s(_vm.localData.woid))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                "margin-left": "120px",
                color: "#666",
                "font-size": "14px"
              }
            },
            [_vm._v("代采时间：" + _vm._s(_vm.localData.create_time))]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                "margin-left": "120px",
                color: "#666",
                "font-size": "14px"
              }
            },
            [_vm._v("市场：" + _vm._s(_vm.localData.market_name))]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.resData
        ? _c(
            "el-row",
            {
              staticClass: "row",
              attrs: {
                gutter: 20,
                type: "flex",
                align: "middle",
                justify: "space-around"
              }
            },
            [
              _c("el-col", { staticClass: "column", attrs: { span: 4.8 } }, [
                _c(
                  "div",
                  {
                    class: _vm.handleClass("getShijiListOfWcg"),
                    on: {
                      click: function($event) {
                        return _vm.selectStatus("getShijiListOfWcg")
                      }
                    }
                  },
                  [_vm._v("\n        实际报单\n      ")]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.resData.wcg_order_info.all_num) +
                      " /\n        " +
                      _vm._s(_vm.resData.wcg_order_info.all_price) +
                      "\n      "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("el-col", { staticClass: "column", attrs: { span: 4.8 } }, [
                _c(
                  "div",
                  {
                    class: _vm.handleClass("getFinishListOfWcg"),
                    on: {
                      click: function($event) {
                        return _vm.selectStatus("getFinishListOfWcg")
                      }
                    }
                  },
                  [_vm._v("\n        已入库\n      ")]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.resData.wcg_order_info.num) +
                      " /\n        " +
                      _vm._s(_vm.resData.wcg_order_info.price) +
                      "\n      "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("el-col", { staticClass: "column", attrs: { span: 4.8 } }, [
                _c(
                  "div",
                  {
                    class: _vm.handleClass("getRjOweListOfWcg"),
                    on: {
                      click: function($event) {
                        return _vm.selectStatus("getRjOweListOfWcg")
                      }
                    }
                  },
                  [_vm._v("\n        退换欠货\n      ")]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.resData.wcg_order_info.rj_owe_num) +
                      " /\n        " +
                      _vm._s(_vm.resData.wcg_order_info.rj_owe_price) +
                      "\n      "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("el-col", { staticClass: "column", attrs: { span: 4.8 } }, [
                _c(
                  "div",
                  {
                    class: _vm.handleClass("getOweListOfWcg"),
                    on: {
                      click: function($event) {
                        return _vm.selectStatus("getOweListOfWcg")
                      }
                    }
                  },
                  [_vm._v("\n        代采欠货\n      ")]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.resData.wcg_order_info.owe_num) +
                      " /\n        " +
                      _vm._s(_vm.resData.wcg_order_info.owe_price) +
                      "\n      "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("el-col", { staticClass: "column", attrs: { span: 4.8 } }, [
                _c(
                  "div",
                  {
                    class: _vm.handleClass("getDedListOfWcg"),
                    on: {
                      click: function($event) {
                        return _vm.selectStatus("getDedListOfWcg")
                      }
                    }
                  },
                  [_vm._v("\n        转抵扣\n      ")]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.resData.wcg_order_info.ded_num) +
                      " /\n        " +
                      _vm._s(_vm.resData.wcg_order_info.ded_price) +
                      "\n      "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("el-col", { staticClass: "column", attrs: { span: 4.8 } }, [
                _c(
                  "div",
                  {
                    class: _vm.handleClass("getRefundListOfWcg"),
                    on: {
                      click: function($event) {
                        return _vm.selectStatus("getRefundListOfWcg")
                      }
                    }
                  },
                  [_vm._v("\n        已退款\n      ")]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.resData.wcg_order_info.refund_num) +
                      " /\n        " +
                      _vm._s(_vm.resData.wcg_order_info.refund_price) +
                      "\n      "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("el-col", { staticClass: "column", attrs: { span: 4.8 } }, [
                _c(
                  "div",
                  {
                    staticClass: "status",
                    class: _vm.handleClass("getBadDebtOfWcg"),
                    on: {
                      click: function($event) {
                        return _vm.selectStatus("getBadDebtOfWcg")
                      }
                    }
                  },
                  [_vm._v("\n        呆账\n      ")]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.resData.wcg_order_info.baddebt_num) +
                      " /\n        " +
                      _vm._s(_vm.resData.wcg_order_info.baddebt_price) +
                      "\n      "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("el-col", { staticClass: "column", attrs: { span: 4.8 } }, [
                _c(
                  "div",
                  {
                    staticClass: "status",
                    class: _vm.handleClass("getBrokenDebtOfWcg"),
                    on: {
                      click: function($event) {
                        return _vm.selectStatus("getBrokenDebtOfWcg")
                      }
                    }
                  },
                  [_vm._v("\n        坏账\n      ")]
                ),
                _vm._v(" "),
                _c("div", [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.resData.wcg_order_info.all_broken_num) +
                      " /\n        " +
                      _vm._s(_vm.resData.wcg_order_info.all_broken_price) +
                      "\n      "
                  )
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "款号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_kh,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_kh", $$v)
                                    },
                                    expression: "form.goods_kh"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "货号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_no", $$v)
                                    },
                                    expression: "form.goods_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.resData.type == 8
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "分类" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "一级分类" },
                                        on: { change: _vm.setResonForSearch },
                                        model: {
                                          value: _vm.form.first_reson,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "first_reson",
                                              $$v
                                            )
                                          },
                                          expression: "form.first_reson"
                                        }
                                      },
                                      _vm._l(_vm.resData.search_reson, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.first.reson_text,
                                          attrs: {
                                            label: item.first.reson_text,
                                            value: item.first.reson_id
                                          }
                                        })
                                      }),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "二级分类" },
                                        model: {
                                          value: _vm.form.reson_id,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "reson_id", $$v)
                                          },
                                          expression: "form.reson_id"
                                        }
                                      },
                                      _vm._l(_vm.resData.reson_2_s, function(
                                        item
                                      ) {
                                        return _c("el-option", {
                                          key: item.reson_text,
                                          attrs: {
                                            label: item.reson_text,
                                            value: item.reson_id
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData.type == 8
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "状态" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "请选择" },
                                        model: {
                                          value: _vm.form.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "status", $$v)
                                          },
                                          expression: "form.status"
                                        }
                                      },
                                      _vm._l(_vm.bdr_options, function(item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData.type == 8
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "通过时间：" } },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "daterange",
                                        "value-format": "yyyy-MM-dd",
                                        "range-separator": "至",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期"
                                      },
                                      model: {
                                        value: _vm.form.cw_audit_time,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "cw_audit_time",
                                            $$v
                                          )
                                        },
                                        expression: "form.cw_audit_time"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", [
                  _vm._v("\n          数据统计："),
                  _vm.resData
                    ? _c("span", { staticStyle: { color: "#666" } }, [
                        _vm._v(_vm._s(_vm.resData.massage))
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.resData.need_selection > 0
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "auto" },
                        attrs: { type: "success", size: "mini" },
                        on: { click: _vm.output }
                      },
                      [_vm._v("导出")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.resData.need_selection == 0
                  ? _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "auto" },
                        attrs: { type: "success", size: "mini" },
                        on: { click: _vm.output }
                      },
                      [_vm._v("导出")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: "转坏账审核",
                      visible: _vm.brokenVisible,
                      width: "30%",
                      center: ""
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.brokenVisible = $event
                      }
                    }
                  },
                  [
                    _c(
                      "el-form",
                      { attrs: { model: _vm.form } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "备注" } },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.form.remark,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "remark", $$v)
                                },
                                expression: "form.remark"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dialog-footer",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                _vm.brokenVisible = false
                              }
                            }
                          },
                          [_vm._v("取 消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.turnToBrokenDebt }
                          },
                          [_vm._v("\n              确 定")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      title: "转呆账审核",
                      visible: _vm.dialogFormVisible,
                      width: "30%",
                      center: ""
                    },
                    on: {
                      "update:visible": function($event) {
                        _vm.dialogFormVisible = $event
                      }
                    }
                  },
                  [
                    _c(
                      "el-form",
                      { attrs: { model: _vm.form } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "分类" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "一级分类" },
                                on: { change: _vm.setReson },
                                model: {
                                  value: _vm.form.first_reson,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "first_reson", $$v)
                                  },
                                  expression: "form.first_reson"
                                }
                              },
                              _vm._l(_vm.resData.reson, function(item) {
                                return _c("el-option", {
                                  key: item.first,
                                  attrs: {
                                    label: item.first,
                                    value: item.first
                                  }
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "二级分类" },
                                model: {
                                  value: _vm.form.reson_id,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "reson_id", $$v)
                                  },
                                  expression: "form.reson_id"
                                }
                              },
                              _vm._l(_vm.resData.reson_2, function(item) {
                                return _c("el-option", {
                                  key: item.reson_text,
                                  attrs: {
                                    label: item.reson_text,
                                    value: item.reson_id
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { label: "备注" } },
                          [
                            _c("el-input", {
                              attrs: { type: "textarea" },
                              model: {
                                value: _vm.form.remark,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "remark", $$v)
                                },
                                expression: "form.remark"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "dialog-footer",
                        attrs: { slot: "footer" },
                        slot: "footer"
                      },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                _vm.dialogFormVisible = false
                              }
                            }
                          },
                          [_vm._v("取 消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.turnToBadDebt }
                          },
                          [_vm._v("确 定")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        key: Math.random(),
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "600",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark"
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _vm.resData.need_selection
                          ? _c("el-table-column", {
                              attrs: {
                                align: "right",
                                type: "selection",
                                width: "55"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "goods_kh",
                            label: "款号"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "goods_no",
                            label: "货号"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_name",
                            label: "商品名称",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "brand_name",
                            label: "品牌",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_img",
                            label: "图片",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          width: "40px",
                                          height: "40px",
                                          overflow: "hidden",
                                          cursor: "pointer",
                                          margin: "auto"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%"
                                          },
                                          attrs: {
                                            src: scope.row.goods_img,
                                            alt: ""
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            412768096
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "co_val",
                            label: "颜色",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "si_val",
                            label: "尺码",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "price",
                            label: "代采单价",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "num",
                            label: "代采数量",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _vm.resData.type == 2
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "stock_in_record_where",
                                label: "库区",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 2
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "stock_in_record_status",
                                label: "状态",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 2
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "admin_name",
                                label: "入库人",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 2
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "create_time",
                                label: "入库时间",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 4
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "status",
                                label: "抵扣状态",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 4
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "w_price",
                                label: "抵扣金额",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 4
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "balance",
                                label: "待抵扣金额",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 4
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "ded_price",
                                label: "已抵扣金额",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 4
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "admin_name",
                                label: "操作人",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 4
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "create_time",
                                label: "操作时间",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 5
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "status",
                                label: "状态",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 5
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "admin_name",
                                label: "操作人",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 5
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "create_time",
                                label: "操作时间",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 8
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "first_reson",
                                label: "一级目录",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 8
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "second_reson",
                                label: "二级目录",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 8
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "remark",
                                label: "备注",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 8
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "broken_debts_record_status",
                                label: "状态",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 8
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "admin_name",
                                label: "审核人",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 8
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "update_time",
                                label: "审核时间",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.resData.type == 6
                          ? _c("el-table-column", {
                              attrs: {
                                prop: "num",
                                label: "操作日志",
                                "show-overflow-tooltip": "",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function($event) {
                                                return _vm.getStagnantDebtDetail(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("\n                操作日志")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-dialog",
                                          {
                                            attrs: {
                                              title: "操作日志",
                                              visible: _vm.dialogTableVisible
                                            },
                                            on: {
                                              "update:visible": function(
                                                $event
                                              ) {
                                                _vm.dialogTableVisible = $event
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "el-table",
                                              { attrs: { data: _vm.gridData } },
                                              [
                                                _c("el-table-column", {
                                                  attrs: {
                                                    property: "source",
                                                    label: "来源",
                                                    align: "center"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    property: "status",
                                                    label: "状态",
                                                    align: "center"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    property: "applicant",
                                                    label: "操作人",
                                                    align: "center"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    property:
                                                      "application_time",
                                                    label: "申请时间",
                                                    align: "center"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    property: "auditor",
                                                    label: "审核人",
                                                    align: "center"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    property: "audit_time",
                                                    label: "审核时间",
                                                    align: "center"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                4164322082
                              )
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper ",
                        total: _vm.resData.pages,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("iframe", {
        attrs: {
          width: "100%",
          height: "3000px",
          src: "./#/purchaseorderdetail/" + _vm.$route.params.id
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a3ed5ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3ed5ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchaseReportDetail.vue
// module id = null
// module chunks = 